import { TagColor } from '@billy/design-system'

import { BillStatus } from '../enums/billStatus'

export const billStatusToTagColor: Record<BillStatus, TagColor> = {
  [BillStatus.All]: 'neutral',
  [BillStatus.Draft]: 'blue',
  [BillStatus.Overdue]: 'red',
  [BillStatus.Paid]: 'green',
  [BillStatus.PartiallyPaid]: 'yellow',
  [BillStatus.Unpaid]: 'yellow',
  [BillStatus.Voided]: 'neutral',
}
